export default __webpack_public_path__ + "static/media/1Enviro Hills.ddffecce.png";